import React, { Component } from 'react'
import BubbleChart from '../charts/BubbleChart/BubbleChartComponent'
import citiesDataJson from '../../assets/data/citiesForeignBorns.json'
import { injectIntl } from 'react-intl';

class Cities extends Component {
  constructor(props) {
    super(props);
    this.state = {
      citiesData: null,
      centered: true,
      step: 0,
    };
  }

  componentDidMount() {
    if (citiesDataJson) {
      const { intl } = this.props;
      const { locale } = intl;
      const values = citiesDataJson.map(city => 
        ({
          id: city.id,
          value: city[`name_${locale}`],
          foreignBornRatio: city.foreignBornRatio, 
          count: city.population,
          img: city.img,
        })
      );
      this.setState({ citiesData: values });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.step !== this.props.step) {
      this.setState({ centered: this.props.step <= 1, step: this.props.step })
    }
    const { intl } = this.props;
    const { locale } = intl;
    if (locale !== prevProps.intl.locale) {
      const values = citiesDataJson.map(city => 
        ({
          id: city.id,
          value: city[`name_${locale}`],
          foreignBornRatio: city.foreignBornRatio, 
          count: city.population,
          img: city.img,
        })
      );
      this.setState({ citiesData: values });
    }
  }

  toggleCentered = () => {
    this.setState({ centered: !this.state.centered }) 
  }

  render() {
    const { citiesData, step } = this.state;
    const { height } = this.props;
    return (
      <div>
        {/*<Row type="flex" justify="end">
          <Radio.Group value={centered} buttonStyle="solid" onChange={this.toggleCentered}>
            <Radio.Button value={true}>Centered</Radio.Button>
            <Radio.Button value={false}>Foreign Born Ratio</Radio.Button>
          </Radio.Group>
        </Row>*/}
        <BubbleChart 
          step={step} 
          data={step > 0 ? citiesData : null} 
          height={height} 
          centered={step > 2 ? false : true}
          showCountry={false}
          highlight={step > 1 && step < 4 ? 'Brussels' : null}
          zoomed={step >= 4}
        />
      </div>
    );
  }
}

export default injectIntl(Cities);